import { Component } from 'react'
import PropTypes from 'prop-types'

import Checkbox from '../FormLegacy/Checkbox'

class AmenityReservationConfirmPopup extends Component {
  constructor(props) {
    super(props)
    this.confirmAction = this.confirmAction.bind(this)
    this.cancelAction = this.cancelAction.bind(this)
    this.setIsRulesConfirmed = this.setIsRulesConfirmed.bind(this)
    this.state = {
      isRulesConfirmed: false,
    }
  }

  confirmAction(e) {
    e.preventDefault()
    this.props.confirmCallback()
  }

  setIsRulesConfirmed(_e) {
    this.setState({ isRulesConfirmed: !this.state.isRulesConfirmed ? 'on' : false })
  }

  cancelAction(e) {
    e.preventDefault()
    this.props.cancelCallback()
  }

  render() {
    const { isOpen, title, cancelText, confirmText, body, className, link, isLoading } = this.props
    return (
      <div className={`modal modal--confirm ${isOpen ? 'is-active' : ''} ${className || ''}`}>
        <div className="modal-background" />
        <div className="modal-content">
          <div className="box">
            <header className="modal__header">
              <span>{title}</span>
              <button
                className="modal-close is-large"
                aria-label="close"
                onClick={this.cancelAction}
              />
            </header>
            <div className="modal__inner">
              {body ? <div className="modal__body">{body}</div> : null}
              {link ? (
                <div className="modal__body">
                  <Checkbox
                    id="confirm-popup-rules-checkbox"
                    name="Notification"
                    checked={this.state.isRulesConfirmed === 'on'}
                    onChange={this.setIsRulesConfirmed}
                    className="org-ntf__box-upper-checkbox"
                  />
                  <span className="modal__body__checkbox-text">
                    I accept the{' '}
                    <a href={link} rel="noreferrer" target="_blank">
                      Rules & Regulations
                    </a>
                  </span>
                </div>
              ) : null}
              <div
                className="modal__section modal__actions"
                style={isLoading ? { pointerEvents: 'none' } : {}}
              >
                <button className="button button-gray" onClick={this.cancelAction}>
                  {cancelText}
                </button>
                <button
                  disabled={link && !this.state.isRulesConfirmed}
                  className={`button ${isLoading ? 'is-loading' : ''} ${
                    className.includes('is-success') ? 'button-primary' : 'button-red'
                  }`}
                  onClick={this.confirmAction}
                >
                  {confirmText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

AmenityReservationConfirmPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  confirmCallback: PropTypes.func,
  cancelCallback: PropTypes.func,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  link: PropTypes.string,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  withRulesConfirmation: PropTypes.bool,
}

AmenityReservationConfirmPopup.defaultProps = {
  className: '',
  isLoading: false,
  withRulesConfirmation: false,
}

export default AmenityReservationConfirmPopup
